import { DEPRECATED_Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";
const inStoreOnlyMessage = "Available in-store only";

type Props = {
  isInStoreOnly: boolean;
};

export const InStoreOnlyMessageBoxUI = ({ isInStoreOnly }: Props) =>
  isInStoreOnly ? (
    <DEPRECATED_Message
      type="warning"
      title={inStoreOnlyMessage}
      containerProps={{ ["data-component"]: "InStoreOnlyMessageBox" }}
    />
  ) : null;
